
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portal/profile",
      function () {
        return require("private-next-pages/portal/profile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portal/profile"])
      });
    }
  